<template>
  <div class="move-copy" @mouseleave="close">
    <div class="title">{{ title }}</div>
    <div class="search">
      <BaseInputSearch
        v-model="search"
        test-id="DietListCopyMoveMenu"
        :debounce-after="100"
        :force-focus="true"
      />
    </div>
    <div class="groups">
      <div
        v-for="group in filteredGroups"
        :key="`move-copy-${group.id}`"
        class="group"
        @click="selectGroup(group)"
      >
        {{ group.name }}
      </div>
    </div>
    <div v-if="!hideAddGroup" class="group-add">
      <StyledButton variant="secondary" left-icon="add" @click="addGroupClick">
        Dodaj grupę
      </StyledButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import type { PropType } from 'vue'
  import { computed, ref } from 'vue'

  import BaseInputSearch from '@/components/BaseInputSearch.vue'
  import { StyledButton } from '@/components/StyledButton'

  import type { GroupOption } from '@/hooks/useDietList'

  const emit = defineEmits(['close', 'selectGroup', 'addGroupClick'])
  const props = defineProps({
    groups: {
      required: true,
      type: Array as PropType<GroupOption[]>,
    },
    hideAddGroup: {
      default: false,
      type: Boolean,
    },
    title: {
      required: true,
      type: String,
    },
  })
  const search = ref('')
  const filteredGroups = computed(() =>
    props.groups.filter(group => group.name.toLowerCase().includes(search.value.toLowerCase())),
  )

  const close = () => {
    emit('close')
  }
  const selectGroup = (group: GroupOption) => {
    emit('selectGroup', group.id)
  }
  const addGroupClick = () => {
    emit('addGroupClick')
  }
</script>

<style scoped>
  .move-copy {
    position: absolute;
    z-index: 90;
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 250px;
    max-height: 338px;
    padding: 12px;
    overflow: hidden;
    font-size: 12px;
    color: var(--color-primary-text);
    background: #fff;
    box-shadow: 0 1px 6px 0 hsl(0deg 0% 61% / 50%);
  }

  .title {
    font-family: Montserrat-SemiBold;
    line-height: 15px;
  }

  .search {
    height: 30px;
  }

  .groups {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    gap: 1px;
    min-height: 100px;
    max-height: 250px;
    overflow: auto;
    scrollbar-width: thin;
  }

  .groups::-webkit-scrollbar {
    width: 6px;
  }

  .group {
    padding: 5px;
    overflow-wrap: break-word;
    cursor: pointer;
  }

  .group:hover {
    font-family: Montserrat-Medium;
    background: var(--color-main-10);
  }

  .group-add {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: center;
    height: 42px;
    min-height: 42px;
    border-top: 1px solid #f5f5f5;
  }
</style>
